import Service from "../Service";

const resource = "SecUserConfiguration/";

export default {
    save(obj) {
        return Service.post(resource + "save", obj, {
            params: {},
        });
    },
    update(obj, requestID) {
        alert('dd');
        return Service.put(resource + "update", obj, {
            params: {},
        });
    },
};